module.exports = __webpack_public_path__ + "media/images/document-icon-small-598c902d0ce90674e6e3c5f4e35aebc2.png";